import { captureException } from '@sentry/browser';
import { wave } from '@/api/config/index.js';
import get from 'lodash/get';

const baseURL = `${process.env.NEXT_PUBLIC_WAVE_HOSTNAME}`;

export async function sendMail(formData) {
  try {
    if (!formData) {
      throw Error('Request failed, no data given.');
    }

    const response = await wave.post(`${baseURL}/api/v3/contact`, formData, {
      headers: {},
    });
    if (response.status !== 200) {
      throw Error('Request failed');
    }
    return {};
  } catch (requestError) {
    captureException(requestError);
    const error = get(requestError, 'response.data.error', {});
    return { error };
  }
}
